import { component } from 'picoapp';
import Modal from 'utils/modal';

export default component(async (node) => {
  const initModals = () => {
    const modals = new Map<string, ReturnType<typeof Modal>>();
    const triggers = node.querySelectorAll<HTMLButtonElement>('[data-trigger]');

    node.querySelectorAll<HTMLElement>('[data-modal]').forEach((element) => {
      const modal = Modal(element);

      document.addEventListener('cart:product:added', () => {
        modal.close();
      });

      modals.set(element.dataset.modal, modal);
    });

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const modal = modals.get(trigger.dataset.trigger);

        if (modal) {
          modal.open();
        }
      });
    });
  };

  const initSlider = async () => {
    const sliderElement = node.querySelector<HTMLElement>('[data-slider]');

    const Swiper = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    )).default;

    const swiperSlider = new Swiper(sliderElement, {
      slidesPerView: 'auto',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    swiperSlider.init();
  };

  initModals();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      if (entry.isIntersecting) {
        initSlider();
        observer.disconnect();
      }
    });
  });

  observer.observe(node);
});
